// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Recognition40FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Recognition40Filled: FC<Recognition40FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
        >
            <path
                d="M20 2.364c7.4 0 13.4 6 13.4 13.4 0 3.193-1.118 6.125-2.983 8.427l4.443 7.694-6.744.925-4.173 5.378L20 31.357l-3.943 6.831-4.173-5.378-6.743-.925 4.441-7.694A13.344 13.344 0 0 1 6.6 15.764c0-7.4 6-13.4 13.4-13.4Zm8.363 23.868a13.334 13.334 0 0 1-6.474 2.798l2.396 4.15 2.32-2.988 3.747-.516-1.989-3.444ZM9.647 29.676l3.748.516 2.319 2.987 2.395-4.15a13.336 13.336 0 0 1-6.473-2.796l-1.989 3.443Zm8.55-12.038-3.236-3.235-1.98 1.98 5.215 5.215 8.472-8.471-1.98-1.981-6.492 6.492Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Recognition40Filled;
